export default {
  current_session_status:'preparing',// registering starting ending
  ajax_spin_count: 0,
  stage_status_list:[],
  language: "",
  user_info: {},
  place_map:{}
}



// WEBPACK FOOTER //
// ./src/store/state.js